import { Watch, Component, Vue, Prop } from 'vue-property-decorator';
import { AgriFieldOutgo, AgriFieldGroupDetail } from '@/types/Component';
import { AgriFieldOutgoResponse, AgriFieldGroupResponse, CsvDownload } from '@/types/APIResponse';
import moment from 'moment';
import { toCamel } from "snake-camel";

@Component({
    filters: {
        changeNumberFormat(value: number): string | null {
            return Math.round(value).toLocaleString().replace(/^-/, '▲')
        }
    }
})

export default class IncomeDetail extends Vue {
    @Prop()
    private agriFieldId!: string

    @Prop()
    private agriFieldGroupId!: string

    private agriFieldGroup: AgriFieldGroupDetail = {
        id: 'other',
        name: '所属なし',
        agriFields: []
    }
    private responseItem: AgriFieldOutgo | null = null
    private sortByAmountAsc = false
    private sortByDateAsc = false;
    private sortBySubjectAsc = false;
    private parentPath = `/aggregation/income-and-outgo/agri-field-groups/${this.agriFieldGroupId}`
    private sortType = "";

    @Prop()
    private startDate!: string
    @Prop()
    private endDate!: string

    created() {
        if(this.agriFieldGroupId != this.agriFieldGroup.id) {
            this.getAgriFieldGroup()
        }
        this.getOutgo()
    }

    private getAgriFieldGroup() {
        this.$apiClient.doRequest('get', `/admin/agri_field_groups/${this.agriFieldGroupId}`).then((res: AgriFieldGroupResponse) => {
            this.agriFieldGroup = toCamel(res) as AgriFieldGroupDetail
        })
    }

    private getOutgo() {
        this.$apiClient.doRequest('get', `/admin/income_and_outgo/agri_field_groups/outgo/${this.agriFieldId}?start_date=${this.startDate}&end_date=${this.endDate}`).then((ret: AgriFieldOutgoResponse) => {
            this.responseItem = toCamel(ret) as AgriFieldOutgo
            this.sortByDate();
        })
    }

    changeQuantityFormat(quantity: number, subject: string, unitName: string): string | null {
        if (quantity === null) {
            return "0";
        }
        switch(subject) {
            case '雇用費':
                return moment.utc().hours(0).minutes(0).add(quantity, 'm').format("H時間m分");
            case '動力光熱費':
                return moment.utc().hours(0).minutes(0).add(quantity, 'm').format("H時間m分");
            case '農薬衛生費':
                return `${quantity.toString()}${unitName}`
            case '肥料費':
                return `${quantity.toString()}${unitName}`
            case '資材費（時間減価償却）':
                return moment.utc().hours(0).minutes(0).add(quantity, 'm').format("H時間m分");
            case '資材費（消耗品）':
                return `${quantity.toString()}`
            case '種苗費':
                return `${quantity.toString()}${unitName}`
            default:
                return `${quantity.toString()}${unitName}`
        }
    }

    sortByAmount() {
        this.sortByAmountAsc = !this.sortByAmountAsc
        this.responseItem?.details.sort((a, b) => this.sortByAmountAsc ?
            a.amount - b.amount : b.amount - a.amount)
    }

    private sortDateClicked() {
        this.sortByDateAsc = !this.sortByDateAsc;
        this.sortByDate();
    }

    private sortBySubject() {
        this.sortBySubjectAsc = !this.sortBySubjectAsc;

        this.responseItem?.details.sort((a, b) => this.sortBySubjectAsc ?
            a.subject.localeCompare(b.subject, 'ja') : b.subject.localeCompare(a.subject, "ja")
        )
    }

    private sortByDate() {
        this.responseItem?.details.sort((a, b) =>
            this.sortByDateAsc ? Date.parse(a.workDate!) - Date.parse(b.workDate!) : Date.parse(b.workDate!) - Date.parse(a.workDate!)
        )
    }

    exportCsv() {
        this.$apiClient.getRequest(`/admin/income_and_outgo/agri_field_groups/outgo/${this.agriFieldId}/csv_export?start_date=${this.startDate}&end_date=${this.endDate}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        })
    }

    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if (document.body.classList.contains('sideopen')) {
            document.body.classList.remove('sideopen')
        } else {
            document.body.classList.add('sideopen')
        }
    }

    onSortChange() {
      switch (this.sortType) {
        case "date":
          this.sortDateClicked();
          break
        case "subject":
          this.sortBySubject();
          break
        case "amount":
          this.sortByAmount();
          break
      }
    }
}